var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex position-relative cursor-pointer",
      attrs: { "data-testid": "searchbar-game-item" },
      on: {
        mousedown: function ($event) {
          return _vm.onCardClick()
        },
      },
    },
    [
      _vm.game
        ? _c(
            "v-container",
            { staticClass: "px-1 pt-1 pb-1", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex py-0 body-2",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-space-between w-100" },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex" },
                            [
                              _c("DriblabCountryFlag", {
                                attrs: { iso: _vm.game.lCC, className: "mr-2" },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "body-2 primary--text text-center",
                                },
                                [_vm._v(_vm._s(_vm.game.lName))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "body-2 text--darken-1 primary--text ml-5",
                            },
                            [_vm._v(_vm._s(_vm.game.date))]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex py-0",
                      attrs: { cols: "12", sm: "10", "offset-sm": "2" },
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass:
                                "py-1 d-flex justify-start align-center",
                              attrs: { cols: "2" },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                    _vm.game.htId +
                                    ".png",
                                  height: 22,
                                  contain: "",
                                },
                                on: {
                                  error: function ($event) {
                                    return _vm.onImageLoadFailure($event)
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass:
                                "py-0 pl-0 d-flex justify-start align-center",
                              attrs: { cols: "3" },
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nav-link text-ellipsis",
                                  attrs: { to: "/team/" + _vm.game.htId },
                                },
                                [
                                  _c("span", { staticClass: "body-2" }, [
                                    _vm._v(_vm._s(_vm.game.htName)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass:
                                "py-0 d-flex justify-center align-center",
                              attrs: { cols: "2" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "flex-grow-1 d-flex justify-end",
                                },
                                [
                                  _c("span", { staticClass: "body-2" }, [
                                    _vm._v(_vm._s(_vm.game.htScore)),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "px-2" }, [
                                _vm._v("-"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-grow-1 d-flex justify-start",
                                },
                                [
                                  _c("span", { staticClass: "body-2" }, [
                                    _vm._v(_vm._s(_vm.game.atScore)),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass:
                                "py-0 d-flex justify-end pr-0 align-center",
                              attrs: { cols: "3" },
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nav-link text-ellipsis",
                                  attrs: { to: "/team/" + _vm.game.atId },
                                },
                                [
                                  _c("span", { staticClass: "body-2" }, [
                                    _vm._v(_vm._s(_vm.game.atName)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass:
                                "py-1 d-flex justify-center align-center",
                              attrs: { cols: "2" },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                    _vm.game.atId +
                                    ".png",
                                  height: 22,
                                  contain: "",
                                },
                                on: {
                                  error: function ($event) {
                                    return _vm.onImageLoadFailure($event)
                                  },
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }